// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import { TokenType } from './type'

export function decode(token: string) {
  return jwt_decode<TokenType>(token)
}
